/**
 * Created by admin on 2017/3/24.
 */
import axios from 'axios';
import config from './config';
import { util, lg } from 'utils';

let base = util.getDomain();

/*�ײ��б�*/
export const PackageByPage = params => { return axios.get(`${base}/api/package/GetERP_PackageByPage`,{ params: params }); };
//�����ײ��б�
export const GetPackageExport = params => { return axios.get(`${base}/api/package/GetPackageExport`,{ params: params }); };
//����ײ�
export const PackageAdd = params => { return axios.post(`${base}/api/package/ERP_PackageAdd`,params,config); };
//�����ײ�
export const PackageUpdate= params => { return axios.post(`${base}/api/package/ERP_PackageUpdate`,params,config); };
//ɾ���ײ�
export const PackageDel= params => { return axios.post(`${base}/api/package/ERP_PackageDel`,params,config); };
//��ȡ�����ײ�
export const GetPackageById = params => { return axios.get(`${base}/api/package/GetPackageById`,{ params: params }); };


// WEBPACK FOOTER //
// ./src/api/packageApi.js